import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
    const services = [
        {
            id: '01',
            title: 'CNC Machining',
            desc: 'Precision CNC machining for high-accuracy industrial components and custom metal parts.',
            image: 'https://sakthivel.ascentbw.com/Files/Home/Ser1.png',
            link: '/services/cnc-machining'
        },
        {
            id: '02',
            title: 'VMC Machining',
            desc: 'Advanced Vertical Machining Center operations for complex and detailed component manufacturing.',
            image: 'https://sakthivel.ascentbw.com/Files/Home/Ser2.png',
            link: '/services/vmc-machining'
        },
        {
            id: '03',
            title: 'Drilling Operations',
            desc: 'High-capacity drilling services with multiple machines ensuring production efficiency.',
            image: 'https://sakthivel.ascentbw.com/Files/Home/Ser3.png',
            link: '/services/drilling-operations'
        },
        {
            id: '04',
            title: 'Milling Operations',
            desc: 'Accurate milling processes for shaping and finishing metal components.',
            image: 'https://sakthivel.ascentbw.com/Files/Home/Ser4.png',
            link: '/services/milling-services'
        },
        {
            id: '05',
            title: 'Metal Cutting',
            desc: 'Precision metal cutting solutions for customized industrial applications.',
            image: 'https://sakthivel.ascentbw.com/Files/Home/Ser5.png',
            link: '/services/metal-cutting'
        }
    ];

    return (
        <section id="services" className="services section-padding">
            <div className="container">
                <h2 className="section-title text-left">Our Engineering Services</h2>

                <div className="services-grid">
                    {services.map((service) => (
                        <div key={service.id} className={`service-card ${service.id === '05' ? 'full-width' : ''}`}>
                            <div className="service-content">
                                <span className="service-number">{service.id}</span>
                                <h3>{service.title}</h3>
                                <p>{service.desc}</p>
                                <Link to={service.link} className={`btn-service ${service.highlight ? 'highlight' : ''}`} style={{ display: 'inline-block', textDecoration: 'none' }}>Learn More</Link>
                                
                            </div>
                            <Link to={service.link} className="service-image" style={{ display: 'block' }}>
                                <img src={service.image} alt={service.title} />
                            </Link>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-40">
                    <Link to="/services" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>Learn More</Link>
                </div>
            </div>
        </section>
    );
};

export default Services;
